import { useCallback } from "react";
import { fetchFilterAutocompleteOptions } from "api";

export const useFilterAutocomplete = (url: string, fieldName: string, operatorName: string) => {
    return useCallback(
        (queryName: string, searchValue: string) => {
            return fetchFilterAutocompleteOptions(url, searchValue, {
                name: fieldName,
                operator: operatorName,
                logicalOperator: "And",
            });
        },
        [fieldName, operatorName, url]
    );
};
